import type { CustomPostAppearance } from "../../api/client";

export const DEFAULT_CUSTOM_POST_APPEARANCE: CustomPostAppearance = {
  deliveryPreference: "auto",
  layout: "media_first",
  buttonAlignment: "center",
  richVideoOverrideAck: false
};

export const moveItem = <T,>(items: readonly T[], from: number, to: number): T[] => {
  if (
    from === to ||
    from < 0 ||
    to < 0 ||
    from >= items.length ||
    to >= items.length
  ) {
    return [...items];
  }
  const next = [...items];
  const [item] = next.splice(from, 1);
  next.splice(to, 0, item);
  return next;
};

export const guardedHttpUrl = (value: string): string | null => {
  const candidate = value.trim();
  if (!candidate) return null;
  try {
    const url = new URL(candidate);
    return url.protocol === "http:" || url.protocol === "https:" ? candidate : null;
  } catch {
    return null;
  }
};

export const effectiveFormatForEditor = (input: {
  appearance: CustomPostAppearance;
  hasVideo: boolean;
  mirrorToMax: boolean;
  richPosts: boolean;
}): "legacy" | "rich" => {
  if (!input.richPosts || input.appearance.deliveryPreference !== "rich") return "legacy";
  if (input.hasVideo) {
    if (input.mirrorToMax) return "legacy";
    if (!input.appearance.richVideoOverrideAck) return "legacy";
  }
  return "rich";
};
